import React from 'react'
import {
    GridCardSkeletonContainer,
    GridCardImageSkeleton,
    GridCardImageWrapperSkeleton,
    GridCardRatingBadgeSkeleton,
    GridCardContent,
    GridCardBottomSection,
    SkeletonBox,
} from './styles'

/**
 * Skeleton component matching the GridCard layout (vertical: image on top, content below)
 * Used for loading states in grid view listings
 */
const GridCardSkeleton: React.FC = () => {
    return (
        <GridCardSkeletonContainer>
            {/* Image placeholder with 3:2 aspect ratio */}
            <GridCardImageWrapperSkeleton>
                <GridCardImageSkeleton />
                <GridCardRatingBadgeSkeleton />
            </GridCardImageWrapperSkeleton>

            <GridCardContent>
                {/* Location text */}
                <SkeletonBox $width="40%" />

                {/* Title */}
                <SkeletonBox $width="85%" />

                {/* Description */}
                <SkeletonBox $width="70%" />

                {/* Bottom section with price */}
                <GridCardBottomSection>
                    <SkeletonBox $width="45%" />
                    <SkeletonBox $width="100%" $height="1.5rem" borderRadius="1rem" />
                    <SkeletonBox $width="65%" />
                </GridCardBottomSection>
            </GridCardContent>
        </GridCardSkeletonContainer>
    )
}

export default GridCardSkeleton
